import { pointerIntersection } from '@dnd-kit/collision';
import { useDroppable } from '@dnd-kit/react';
import { GalleryImageSize } from '../constants';
import type { VehicleImage } from '../types';

type PlaceholderProps = {
  id: string;
};

export const PlaceholderID = '-1';
export const PlaceholderImage: VehicleImage = {
  id: PlaceholderID,
  vehicle_listing_id: '0',
  order_index: 0,
  image_url: '',
  blur_hash_img: '',
  status: '',
  featured: false,
  timestamp: 0,
  type: 'placeholder',
  category: { value: '', label: '' },
};

export const Placeholder = ({ id }: PlaceholderProps) => {
  const { ref } = useDroppable({
    id,
    type: 'placeholder',
    accept: 'vehicle-image',
    collisionDetector: pointerIntersection,
  });

  return (
    <div
      ref={ref}
      id="drag-placeholder"
      className="placeholder border-dashed border-3 rounded"
      style={GalleryImageSize}
    ></div>
  );
};
